import React, { type FC } from 'react';
import { CardContainer, CardTitle } from 'layout/Card';
import { type EnergyAudit } from 'interfaces/EnergyAudit.interface';
import Skeleton from 'react-loading-skeleton';
import EnergyAuditKPICards from './EnergyAuditKPICards';
import ventilationImg from 'assets/images/standby.png';
import solarImg from 'assets/images/solar.png';
import capacityTariffImg from 'assets/images/capacity-tariff.png';

const ENERGY_AUDIT_CATEGORIES = {
  STANDBY_CONSUMPTION: 'analytic_01_standby_consumption',
  SOLAR: 'analytic_02_solar_pv',
  CAPACITY_TARIFF: 'analytic_03_capacity_tariff',
};

const EnergyAuditSummaryCard: FC<{
  data?: EnergyAudit;
  isFetching?: boolean;
}> = ({ data, isFetching }) => {
  return (
    <CardContainer>
      <div className="flex gap-8 items-center">
        {isFetching ? (
          <Skeleton width={480} height={286} />
        ) : data?.analytic_name ===
          ENERGY_AUDIT_CATEGORIES.STANDBY_CONSUMPTION ? (
          <img
            src={ventilationImg}
            alt="Ventilation"
            width={480}
            height={286}
            className="rounded-lg object-cover"
          />
        ) : data?.analytic_name === ENERGY_AUDIT_CATEGORIES.SOLAR ? (
          <img
            src={solarImg}
            alt="Solar"
            width={480}
            height={286}
            className="rounded-lg object-cover"
          />
        ) : data?.analytic_name === ENERGY_AUDIT_CATEGORIES.CAPACITY_TARIFF ? (
          <img
            src={capacityTariffImg}
            alt="Capacity Tariff"
            width={480}
            height={286}
            className="rounded-lg object-cover"
          />
        ) : (
          <div className="w-[480px] h-[286px] bg-gray-20 rounded-lg flex items-center justify-center text-gray-40 text-lg">
            No image
          </div>
        )}
        <div className="flex flex-col gap-6 flex-1">
          <div className="flex flex-col gap-4">
            <CardTitle title="Summary" fontSize="sm" />
            <div className="text-gray-60 text-sm leading-[21px] font-sans">
              {isFetching ? (
                <Skeleton count={3} />
              ) : (
                data?.summary
                  ?.split('\n')
                  .map((line: string, idx: number) => <p key={idx}>{line}</p>)
              )}
            </div>
          </div>
          <EnergyAuditKPICards data={data} isFetching={isFetching} />
        </div>
      </div>
    </CardContainer>
  );
};

export default EnergyAuditSummaryCard;
